export const DISPUTED = 'DISPUTED';
export const CANCELLED = 'CANCELLED';
export const CERTIFIED = 'CERTIFIED';
export const PUBLISHED = 'PUBLISHED';

export const TUTORING_BUTTON_ACTIONS = [
  { key: '1', value: 'customizations.documents.questions.certify', profile: 'tutorization.questions' },
  { key: '2', value: 'customizations.documents.questions.publish', profile: 'tutorization.questions' },
  { key: '3', value: 'customizations.documents.questions.cancel', profile: 'tutorization.questions' },
  { key: '4', value: 'customizations.documents.questions.delete', profile: 'tutorization.questions' },
  { key: '5', value: 'actions.edit', profile: 'subscriptions.questions' }
];
